import { API_ENDPOINTS } from '../config/apiConfig';
import {
  DashboardAddedRtusRange,
  DashboardAddedRtusResponseDto,
  DashboardDistributionResponseDto,
  DashboardReachabilitySummaryDto,
} from '../types/DashboardInsights';
import apiClient from './apiClient';

export const dashboardInsightsService = {
  async currentReachability(): Promise<DashboardReachabilitySummaryDto> {
    const response = await apiClient.get<DashboardReachabilitySummaryDto>(
      API_ENDPOINTS.DASHBOARD.REACHABILITY_CURRENT
    );
    return response.data;
  },

  async imageVersions(): Promise<DashboardDistributionResponseDto> {
    const response = await apiClient.get<DashboardDistributionResponseDto>(
      API_ENDPOINTS.DASHBOARD.IMAGE_VERSIONS
    );
    return response.data;
  },

  async addedRtus(range: DashboardAddedRtusRange): Promise<DashboardAddedRtusResponseDto> {
    const response = await apiClient.get<DashboardAddedRtusResponseDto>(
      API_ENDPOINTS.DASHBOARD.RTUS_ADDED,
      { params: { range } }
    );
    return response.data;
  },
};

export default dashboardInsightsService;
